module.exports = __webpack_public_path__ + "assets/670b09b5a253efa916c029f3f9b15196.png";